import { forwardRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
// Styles
import styles from "./Radio.module.scss";

const Radio = forwardRef(
  ({ className, disabled, name, label, value, error, ...restProps }, ref) => {
    return (
      <div className={styles.root}>
        <input
          className={styles.radioInput}
          disabled={disabled}
          id={`${name}-${value}`}
          name={name}
          type="radio"
          value={value}
          ref={ref}
          {...restProps}
        />
        <label
          className={cn(styles.label, {
            [styles.disabled]: disabled,
          })}
          htmlFor={`${name}-${value}`}
        >
          {label}
        </label>
      </div>
    );
  }
);

Radio.defaultProps = {
  className: "",
  disabled: false,
};

Radio.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  error: PropTypes.string,
};

export default Radio;
